export default window.__litium.constants;

export const StockStatus = {
    Green: "Green",
    RedLow: "RedLow",
    RedMedium: "RedMed",
    RedHigh: "RedHigh",
    RedMax: "RedMax",
    RedHighest: "RedHighest",
    Yellow: "Yellow",
}